import api from "../api";

export const useGenerateUser = () =>
  api.post("/user/generate-test").then((res) => res.data);
